import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TheRave} from "../../TheRave";
import {TheRaveSymbol} from "../../symbol/TheRaveSymbol";
import {TimelineLite} from "gsap";
import {TheRaveScatterSymbol} from "../../symbol/TheRaveScatterSymbol";
import {IEnhancerReel} from "../../server/data/ITheRaveData";
import {TheRaveSound} from "../../sound/TheRaveSound";
import {TheRaveParsedGameData} from "../../server/data/TheRaveParsedGameData";

export class SymbolLandingAnimationController extends ReelStopPresentationController {
    private _stopTl: TimelineLite;
    private _bounceTl: TimelineLite;
    private _playingXwGlow:boolean = false;

    constructor() {
        super("SymbolLandingAnimationController");
    }

    private isSpecialSymbol(symName: string): boolean {
        return (["XS", "S", "W", "XW"].indexOf(symName) > -1);
    }

    private isEnhancer(reel: number, symbol:number): boolean {
        if(!TheRave.model.parsedGameData.enhancerReel[reel]){
            return false;
        }
        let isEnhancerGrid:boolean = false;
        TheRave.model.parsedGameData.scatterEnhancers.forEach((scatterEnhancer:IEnhancerReel)=>{
            if(scatterEnhancer.reelId === reel && scatterEnhancer.symbolId === symbol){
                isEnhancerGrid = true
            }
        });
        return isEnhancerGrid;
    }

    protected async onReelBounce(data: IReelStateEventData): Promise<any> {
        const tl: TimelineLite = new TimelineLite(),
            reelId: number = data.reelId,
            enhancerReelId: number = reelId - 5,
            gameData:TheRaveParsedGameData = TheRave.model.parsedGameData;

        if (reelId < 4 && !TheRave.reels[reelId].isQuickStop) {
            TheRave.nearwinPresentation.onContinueNearWinAnimation(reelId);
        }

        if (reelId < 5 && gameData.isFreespin) {
            if (gameData.doLowToWildReels[reelId]) {
                if(TheRave.model.reels[reelId][1][0] === "L"){
                    TheRave.reels[reelId].getSymbol(1, true).playWildBlink();
                }
                if(TheRave.model.reels[reelId][2][0] === "L"){
                    TheRave.reels[reelId].getSymbol(2, true).playWildBlink();
                }
            }
        }

        if(reelId < 5 && TheRave.model.isFreespin && TheRave.model.doDoubleXways[reelId]) {
            //console.log("XWAY LAND :: XWINDEX: " + xwIndex);
            let reelSymbols:string[] = TheRave.model.parsedGameData.reels[reelId].concat();
            reelSymbols[0] = "M1";
            const xwIndex:number = reelSymbols.indexOf("XW");
            if (xwIndex > 0 && xwIndex < 4) {
                tl.add(() => {
                    TheRave.xwaysEqView.playXwayGlow(reelId, () => {}, true, xwIndex - 1);
                    this._playingXwGlow = true;
                }, 0);
            }
        }

        if(reelId > 4 && TheRave.model.isFreespin) {
            //const tm = TheRave.enhancerReels[reelId - 5].getSymbol(0).symbolName === "XW";
            //console.log("ENHANCER reels for rId: " + reelId, TheRave.model.parsedGameData.reels);
            //console.log("ENHANCER doDoubleXways", TheRave.model.doDoubleXways);
            //console.log("ENHANCER LANDING XW, reelId: " + reelId + " symbolNAME :: id :: 0: " + TheRave.enhancerReels[reelId - 5].getSymbol(0).symbolName);

            if(TheRave.enhancerReels[reelId - 5].getSymbol(0).symbolName === "XW") {
                TheRave.enhancerReels[reelId - 5].playXwayAttentionInFs(2);
                this._playingXwGlow = true;
            }
        }

        TheRave.model.parsedGameData.reels[reelId].forEach((symbolName: string, id: number) => {
            //console.log(`${reelId}, ${id} is ${symbolName}`);
            if (this.isSpecialSymbol(symbolName)) {
                if (reelId < 5) {
                    if (id > 0 && id < 4) {
                        const symbol: TheRaveSymbol = TheRave.reels[reelId].getSymbol(id, true);
                        tl.add(() => TheRave.reels[reelId].reelView.addWinSymbol(symbol), 0);
                        if (symbolName === "S") {
                            //console.log("SCATTER LAND, ADD LAND on rId: " + reelId);
                            //if(reelId === 4) {

                            // #177 Removed trigger from timeline
                            TheRave.scatterController?.playScatterLandingAnimation(reelId, id, <TheRaveScatterSymbol>symbol, this.isSkip);
                            //}
                            //else {
                                //tl.add(() => TheRave.scatterController?.playScatterLandingAnimation(reelId, id, <TheRaveScatterSymbol>symbol), 0);
                            //}
                        } else {
                            if(!this.isEnhancer(reelId, id-1)){
                                tl.add(symbol.playLanding(false, reelId), 0);
                            }
                        }
                    }
                }
            }
        });

        if (reelId === 4 && !TheRave.model.parsedGameData.isFreespin) {
            TheRave.scatterController.reset();
            let hasEnhancer:boolean = false;
            TheRave.model.currentParsedData.scatterEnhancers.forEach((reel: IEnhancerReel, i: number) => {
                hasEnhancer = true;
                tl.add(() => {
                    TheRave.enhancerReels[reel.reelId].reelView.playUnLock(i);
                    TheRave.reels[reel.reelId].getSymbol(reel.symbolId).visible = false;
                }, 0.5);

            });
            if(hasEnhancer){
                TheRave.scatterController.removeScatterAnimations();
                tl.add(() => TheRaveSound.playSoundEffect("scatterRespin"), 0);
            }
        }

        tl.to(this, {duration: 0.1});
        this._bounceTl = tl;
        // TODO: Tl sanity
        await Promise.resolve(this._bounceTl);
    }

    protected async onReelStopped(data: IReelStateEventData): Promise<any> {
        const tl: TimelineLite = new TimelineLite(),
            reelId: number = data.reelId;

        if ((reelId > 5 && reelId < 9) && TheRave.model.isFreespin && (TheRave.model.parsedGameData.reels[reelId][0][0] === "M")) {
            TheRave.stickySymbol.setMultiplierActive((reelId - 5));
        }

        if(reelId === 4) {
            TheRave.xwaysEqView.resetAllXwayGlows();
            TheRave.enhancerReels.forEach((ereel) => {
                ereel.xwayAttentionComplete();
            });
        }

        tl.to(this, {duration: 0.1});
        this._stopTl = tl;
        // TODO: Tl sanity
        Promise.resolve(this._stopTl);
    }

    public skip() {
        this.isSkip = true;
        if (this._stopTl) {
            this._stopTl.timeScale(2);
        }
        if (this._bounceTl) {
            this._bounceTl.timeScale(2);
        }

    }
}